import script from "./LowMei.vue?vue&type=script&setup=true&lang=ts"
export * from "./LowMei.vue?vue&type=script&setup=true&lang=ts"

import "./LowMei.vue?vue&type=style&index=0&id=e90014ba&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e90014ba"]])

export default __exports__